<template>

    <div class="p-3">
      <div class="wrap">
        <button onclick="javascript:window.print()" class="btn-print extrade-print">
            <i class="fas fa-print"></i> Print PDF
        </button>
      </div>
     <h3 class="text-center">Print Ticket </h3>
     <h3 v-if="printData.length == 0 && loading" class="text-center">Loading...</h3>
     <h3 v-if="printData.length == 0 && !loading" class="text-center">No data available</h3>
     <div class="print-container m-auto border border-dark" v-for="data in printData" :key="data.cusip">
       <table class="table m-0">
         <tr>
           <td class="border-0">
             <table class="table border-bottom border-dark m-0">
              <tbody>
                <tr>
                  <td class="border-right border-dark border-top-0"><h5 class="text-uppercase">TRADE<br>DATE</h5></td>
                  <td align="center" class="align-middle border-right border-dark border-top-0">{{data.tradeDate}}</td>
                  <td class="border-right border-dark border-top-0"><h5 class="text-uppercase">SETTLEMENT<br>DATE</h5></td>
                  <td align="center" class="align-middle border-right border-dark border-top-0">{{data.settlementDate}}</td>
                  <td class="border-right border-dark border-top-0">
                    <div class="row no-gutters text-center">
                      <div class="col"><h5 class="text-uppercase">BOT<br><div v-if="isAutoBidder">BBBB</div></h5></div>
                      <div class="col"><h5 class="text-uppercase">SOLD<br><div v-if="!isAutoBidder">SSSSSSS</div></h5></div>
                    </div>
                  </td>
                  <td class="border-right border-dark border-top-0"><h5 class="text-uppercase">CUSIP<br>NUMBER</h5></td>
                  <td align="center" class="align-middle  border-top-0">{{data.cusip}}</td>
                </tr>
              </tbody>
            </table>
           </td>
         </tr>
         <tr>
           <td>
             <table class="table border-bottom border-dark m-0">
              <tbody>
                <tr>
                  <td class="border-right border-dark border-top-0">
                    <h5 class="text-uppercase">Quantity</h5>
                    {{data.quantity}}
                  </td>
                  <td class="border-top-0" style="width: 415px;">
                    <h5 class="text-uppercase">Bond name</h5>
                    <span class="text-break">{{data.bondName}}</span>
                  </td>
                  <td class="border-top-0">
                    <h5 class="text-uppercase">Coupon</h5>
                    <span>{{data.coupon}}</span>
                  </td>
                  <td class="border-right border-dark border-top-0">
                    <h5 class="text-uppercase">Maturity</h5>
                    <span>{{data.maturity}}</span>
                  </td>
                  <td class="px-0 border-top-0">
                    <h5 class="text-uppercase pl-1">Dollar Price</h5>
                    <span class="pl-1">{{data.executedPrice}}</span>
                    <div class="row no-gutters border-top border-dark pt-1 pl-1">
                      <div class="col"><h5 class="text-uppercase">BASIS PX </h5></div>
                      <div class="col"><h5 class="text-uppercase">PX TO CALL</h5></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
           </td>
         </tr>
         <tr>
           <td>
             <table class="table m-0">
               <tr>
                 <td class="border-right border-bottom border-dark border-top-0" colspan="2">
                   <h5 class="text-uppercase">BROKER OR CLIENT<br>ACCOUNT NO</h5>
                 </td>
                 <td class="border-right border-bottom border-dark border-top-0" width="30">
                   <span style="text-orientation: upright;writing-mode: vertical-rl;">TYPE</span>
                 </td>
                 <td class="border-right border-bottom border-dark border-top-0">
                   <h5 class="text-uppercase">INV BROKER NO</h5>
                 </td>
                 <td class="border-right border-bottom border-dark border-top-0">
                   <h5 class="text-uppercase">INV BROKER NO</h5>
                 </td>
                 <td width="45%">
                   <h5 class="text-uppercase">ACCOUNT# CONTRA BROKER</h5>
                   <div class="pl-4">{{data.account}}</div>
                   <div class="pl-4 d-flex" style="justify-content: space-between;">
                    <div>{{data.contraBroker}}</div>
                    <div v-if="isRetailHolding" class="" style="margin-right: 60px;">S</div>
                  </div>
                 </td>
               </tr>
               <tr>
                 <td class="border-right border-dark" width="30">
                 </td>
                 <td class="border-right border-dark">
                   <h5 class="text-uppercase">Number</h5>
                 </td>
                 <td class="border-right border-dark" width="30">
                   
                 </td>
                 <td class="border-right border-dark">
                   
                 </td>
                 <td class="border-right border-dark">
                   
                 </td>
                 <td width="45%" class="border-top-0">
                   <table class="table m-0 ml-4">
                     <tr>
                       <td class="pl-0 border-top-0">
                         YTW<br>
                         {{data.ytw}}
                       </td>
                       <td class="border-top-0">
                         Interest<br>
                        {{data.interest}}
                       </td>
                     </tr>
                   </table>
                 </td>
               </tr>
               <tr>
                 <td class="border-right border-dark" width="30">
                 </td>
                 <td class="border-right border-dark">
                   <h5 class="text-uppercase">{{data.brokerClientAccount}}</h5>
                 </td>
                 <td class="border-right border-dark" width="30">
                   {{data.type}}
                 </td>
                 <td class="border-right border-dark">
                   783
                 </td>
                 <td class="border-right border-dark">
                   {{data.spread}}
                 </td>
                 <td width="45%" class="border-dark py-0">
                   <table class="table m-0">
                     <tr v-if="data.account && !data.account.includes('MKTX')">
                       <td class="border-top-0 border-right border-dark" width="60" height="40">
                         pmp
                       </td>
                       <td class="border-top-0">
                        {{data.pmp}}
                       </td>
                     </tr>
                   </table>
                 </td>
               </tr>
               <tr>
                 <td class="border-right border-dark px-0" colspan="5">
                   <div class="border-bottom border-dark px-2">
                     <h5 class="text-uppercase m-0">BOT FROM OR SOLD TO FIRM ACCOUNT NUMBER</h5>
                   </div>
                   <div><h5></h5></div>
                 </td>
                 
                 <td width="45%" class="border-dark py-0">
                  <h5 class="text-uppercase m-0"> {{data.executedAt}}   ATM Eastern Time </h5>
                 </td>
               </tr>
             </table>
           </td>
         </tr>
       </table>
       <br>
     </div>
    </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "printticket",
   components: {

  },
  data() {
    return {
      printData : [],
      loading : false,
      isAutoBidder : false,
      isRetailHolding : false
    };
  },
  methods: {
    getTicketsForOffer(offerId){
      this.loading = true;
      const auth = {
        headers: { 'org-token' : authService.getOrgToken()  }
      };
      this.$http
      .get(config.baseUrlBidSide + "/excel/download-data?offerId="+offerId,auth)
      .then((response) => {
        this.printData = response.data;
        //this.printData = response.data.push(response.data[0]);
        this.loading = false;

      })
      .catch(() => {
        this.loading = false;

      });
    },
    getTicketsForBid(bidId){
      this.loading = true;
      const auth = {
        headers: { 'org-token' : authService.getOrgToken()  }
      };
      this.$http
      .get(config.baseUrlBidSide + "/bidwanted/ticket-data?bidWantedId="+bidId,auth)
      .then((response) => {
        this.printData = response.data;
        //this.printData = response.data.push(response.data[0]);
        this.loading = false;

      })
      .catch(() => {
        this.loading = false;

      });
    },
    getTicketsForAutoBid(bidId){
      this.loading = true;
      const auth = {
        headers: { 'org-token' : authService.getOrgToken()  }
      };
      this.$http
      .get(config.baseUrlAutoBidder + "/autobidder/ticket-data?id="+bidId,auth)
      .then((response) => {
        this.printData = response.data;
        //this.printData = response.data.push(response.data[0]);
        this.loading = false;

      })
      .catch(() => {
        this.loading = false;

      });
    }
    
  },
  mounted() {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var offerId = url.searchParams.get("id");
    var bidId = url.searchParams.get("bidId");
    var autobidId = url.searchParams.get("autobidId");
    this.isRetailHolding = url.searchParams.get("isInventory") === "false";
    if(offerId){
      this.getTicketsForOffer(offerId);
    }
    if(bidId){
      this.getTicketsForBid(bidId);
    }
    if(autobidId){
      this.isAutoBidder = true;
      this.getTicketsForAutoBid(autobidId);
    }
  }
};
</script>
<style>
.wrap {
  background: #fff;
  padding: 20px;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  position: relative;
}
.extrade-print {
  position: fixed;
  right: 50px;
  top: 20px;
  border: 0;
  outline: none;
  background:#FF9E47;
  color:#fff;
  padding: 13px;
  border-radius: 5px !important;
}
.m-auto{
  margin-bottom : 25px !important
}
@media print {
  .extrade-print {
    display: none;
  }
}
</style>